var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Field, SubCollection, Collection, File } from '@1amageek/ballcap';
import { Base } from '.';
import { Utils } from '../../../common/helper';
export class User extends Base {
    constructor() {
        super(...arguments);
        // カウンター
        this.workerCounter = new Collection();
        // 申請した求人状況
        this.jobsApplied = new Collection();
        // 過去の業務
        this.jobHistories = new Collection();
        // チェックイン状況
        this.jobCheckIns = new Collection();
        // ペナルティ
        this.penalty = new Collection();
        // 機密情報（身分証、保有資格証、履歴書）
        this.confidential = new Collection();
        // クリニックによる評価
        this.reviewPostsFromClinic = new Collection();
        // アクティブ状態
        this.activity = new Collection();
    }
    static collectionReference() {
        return super.collectionReference().doc('v1').collection('users');
    }
    fullName() {
        if (Utils.isNull(this.lastName) || Utils.isNull(this.firstName)) {
            return '';
        }
        return `${this.lastName} ${this.firstName}`;
    }
}
__decorate([
    Field,
    __metadata("design:type", String)
], User.prototype, "firstName", void 0);
__decorate([
    Field,
    __metadata("design:type", String)
], User.prototype, "lastName", void 0);
__decorate([
    Field,
    __metadata("design:type", Number)
], User.prototype, "genderId", void 0);
__decorate([
    Field,
    __metadata("design:type", String)
], User.prototype, "birthday", void 0);
__decorate([
    Field,
    __metadata("design:type", String)
], User.prototype, "email", void 0);
__decorate([
    Field,
    __metadata("design:type", String)
], User.prototype, "tel", void 0);
__decorate([
    Field,
    __metadata("design:type", Number)
], User.prototype, "prefectureId", void 0);
__decorate([
    Field,
    __metadata("design:type", String)
], User.prototype, "locationAddress", void 0);
__decorate([
    Field,
    __metadata("design:type", Boolean)
], User.prototype, "isArchive", void 0);
__decorate([
    Field,
    __metadata("design:type", Number)
], User.prototype, "clinicalExperienceYearsId", void 0);
__decorate([
    Field,
    __metadata("design:type", File
    // 最終職歴
    )
], User.prototype, "image", void 0);
__decorate([
    Field,
    __metadata("design:type", String)
], User.prototype, "lastWorkplace", void 0);
__decorate([
    Field,
    __metadata("design:type", String)
], User.prototype, "currentWorkplace", void 0);
__decorate([
    SubCollection,
    __metadata("design:type", Collection)
], User.prototype, "workerCounter", void 0);
__decorate([
    SubCollection,
    __metadata("design:type", Collection)
], User.prototype, "jobsApplied", void 0);
__decorate([
    SubCollection,
    __metadata("design:type", Collection)
], User.prototype, "jobHistories", void 0);
__decorate([
    SubCollection,
    __metadata("design:type", Collection)
], User.prototype, "jobCheckIns", void 0);
__decorate([
    SubCollection,
    __metadata("design:type", Collection)
], User.prototype, "penalty", void 0);
__decorate([
    SubCollection,
    __metadata("design:type", Collection)
], User.prototype, "confidential", void 0);
__decorate([
    SubCollection,
    __metadata("design:type", Collection)
], User.prototype, "reviewPostsFromClinic", void 0);
__decorate([
    SubCollection,
    __metadata("design:type", Collection)
], User.prototype, "activity", void 0);
